import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { AppIconComponent } from '../../../../../shared/components/app-icon/app-icon.component';

@Component({
  selector: 'app-admin-panel-nav-card',
  imports: [AppIconComponent],
  templateUrl: './admin-panel-nav-card.html',
  styleUrl: './admin-panel-nav-card.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AdminPanelNavCard {
  public readonly label = input<string>();
  public readonly icon = input<string>();
}
